import { render, staticRenderFns } from "./dashboard-restaurants.vue?vue&type=template&id=e805d92c&scoped=true"
import script from "./dashboard-restaurants.vue?vue&type=script&lang=js"
export * from "./dashboard-restaurants.vue?vue&type=script&lang=js"
import style0 from "./dashboard-restaurants.vue?vue&type=style&index=0&id=e805d92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e805d92c",
  null
  
)

export default component.exports